export default __webpack_public_path__ + "static/media/Dia-internacional-dasMulheres-8M-2.edbf29de.jpg";